import { render, staticRenderFns } from "./dialogedit.vue?vue&type=template&id=c8e035e6&scoped=true"
import script from "./dialogedit.vue?vue&type=script&lang=js"
export * from "./dialogedit.vue?vue&type=script&lang=js"
import style0 from "./dialogedit.vue?vue&type=style&index=0&id=c8e035e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e035e6",
  null
  
)

export default component.exports